let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dmOuG")).then(() => parcelRequire('fMKFm'));